import { useQuery } from "react-query";
import { API_KEY_GET_LANDING_PAGES_LIST } from "../utils";
import { getLandingPagesList } from "../api";

export const useGetLandingPagesList = (params) => {
  return useQuery([API_KEY_GET_LANDING_PAGES_LIST, params], () =>
    getLandingPagesList(params)
  );
};
